//* ------------------------------------*\
//    $CLASS NAMES - for class names
//      not CSS selectors
//* ------------------------------------*/

const CLASS_NAMES = {
  ABOVE_BOTTOM: 'above-bottom',
  ABOVE_HALFWAY: 'above-halfway',
  ABOVE_VIEWPORT: 'above-viewport',
  ACCORDION_CONTAINER: 'accordion-container',
  ACCORDION_HIDE: 'accordion-hide',
  ACCORDION_ICON: 'accordion-icon',
  ACCORDION_ITEM: 'accordion-item',
  ACCORDION_ITEM_JS: 'accordion-item-js',
  ACCORDION_MINUS: 'accordion-minus',
  ACTIVE: 'active',
  ALERT_ACTIVE: 'alert-active',
  ALERT_ICON: 'alert__icon',
  ALERT_FOOTER_ACTIVE: 'alert-footer-active',
  ALERT_FOOTER_CLOSE: 'alert-footer__close',
  ALERT: 'alert',
  ALERT_CLOSE: 'alert__close',
  ANIMATE: 'animate',
  ANIMATED: 'animated',
  BACKGROUND_ADDED: 'background-added',
  BASIC_LIGHTBOX: 'basicLightbox',
  BELOW_BOTTOM: 'below-bottom',
  BELOW_HALFWAY: 'below-halfway',
  BELOW_VIEWPORT: 'below-viewport',
  BLINK: 'blink',
  BODY_TEXT_CONTENT: 'body-text__content',
  BUTTON_PRIMARY: 'button__primary',
  CANCEL_DONATION_SELECTED: 'cancel-donation-selected',
  CARD_EYEBROW: 'listing-cards__content h6',
  CARE_BUTTON: 'careButton',
  CASE_REASON: 'case-reason',
  CASE_REASON_2: 'case-reason2',
  CAPTCHA_ERROR_TEXT: 'captcha-error-text',
  CHECKED: 'checked',
  CLEAR_ALL: 'clear-all',
  CLICK: 'click',
  CLOSED: 'closed',
  CONTAINER: 'container',
  CONTENT_DETAIL_HERO: 'content-detail-hero',
  CTA_BLOCK_WRAPPER: 'cta-block__wrapper',
  CTA_BLOCK_WRAPPER_INNER: 'cta-block__wrapper-inner',
  CONTENT_WRAPPER_JS: 'content-wrapper--js',
  COUNTRY_INTRO: 'country-intro',
  COUNTRY_SIDEBAR_WRAP: 'sidebar-country__wrapper',
  DARK_BG_CAMPAIGN_HERO_HEADLINE: 'dark-bg-campaign-hero__headline',
  DARK_BG_CAMPAIGN_HERO_SUBHEADLINE: 'dark-bg-campaign-hero__subheadline',
  DONATE: 'donate',
  DONATE_BOX_CONTENT_WRAPPER: 'donate-box__content-wrapper',
  DONATE_BOX_HOVER_IMAGE: 'donate-box__image-circle',
  DONATE_FULL: 'header__donate-full',
  DONATE_BOX_IMAGE_BC_FULL: 'donate-box__image-bc-full',
  DONUT_PIE: 'donut-pie',
  EMAIL_BLOCK_EMAIL: 'email-block__email',
  EMERGENCY_STATISTICS_CARD_CONTENT: 'emergency-statistics__card-content',
  EMERGENCY_STATISTICS_CARD_INNER: 'emergency-statistics__card-inner',
  EMERGENCY_STATISTICS_WRAPPER: 'emergency-statistics__wrapper',
  EMBED_FORM: 'embed-form',
  ERROR_TEXT: 'error-text',
  ERROR: 'error',
  EVENT_SIGNUP_CHECKBOX: 'checkbox',
  EVENT_SIGNUP_DESCRIPTION: 'event-signup-form__description',
  EVENT_SIGNUP_FORM: 'msform',
  EVENT_SIGNUP_INPUTS: 'input[required]',
  EVENT_SIGNUP_SECTION_HEADING: 'section-heading',
  EVENT_SIGNUP_THANK_YOU_DESCRIPTION:
    'event-signup-form__thank-you-description',
  EVENT_SIGNUP_THANK_YOU_HEADLINE: 'event-signup-form__thank-you-headline',
  EXPAND: 'expand',
  EXPAND_LIST: 'expand-list',
  FACET_MORE_ADDED: 'facet-more-added',
  FACET_MORE_TOGGLE: 'facet-more-toggle',
  FACETWP_CHECKBOX: 'facetwp-checkbox',
  FADE: 'fade',
  FADE_LEFT: 'fade-left',
  FADE_RIGHT: 'fade-right',
  FEATURED_NEWS_STORIES: 'featured-news-stories',
  FILTER_SELECTED: 'filter-selected',
  FIRST_BATCH: 'first-batch',
  FIXED: 'fixed',
  FILTERED: 'filtered',
  FLAGSHIP_CLOSE_JS: 'flagship__close--js',
  FLAGSHIP_WRAPS: 'flagship__wrap',
  FLAGSHIP_WRAP_JS: 'flagship__wrap--js',
  FLAGSHIP_ICON: 'flagship__icon',
  FOCUSED: 'focused',
  FOOTER_PIE: 'footer-pie',
  FW_STAT_COUNTER: 'fw-stat__counter',
  FW_STAT_COUNTER_VALUE: 'fw-stat__counter-value',
  FW_STAT_STAT_MD_PIE: 'fw-stat__stat-md-pie',
  GENERAL_EMAIL_FORM: 'general-email-form',
  GEO_LOCATION_COLUMN: 'geo-location-popup__column',
  GEO_LOCATION_POPUP_HIDDEN: 'geo-location-popup-hidden',
  GEO_LOCATION_POPUP_BACKDROP: 'geo-location-popup__backdrop',
  GEO_LOCATION_POPUP_CLOSE: 'geo-location-popup__close',
  G_RECAPTCHA: 'g-recaptcha',
  HEADER__BRANDING: 'header__branding',
  HEADER__DONATE_DROPDOWN_ARROW: 'header__donate-dropdown-arrow',
  HEADER__DONATE_LINK: 'header__donate-link',
  HEADER__DONATE_LINK_FULL_HOVER: 'header__donate-full--hover',
  HEADER__DONATE_LINK_CLICKED: 'header__donate-link--clicked',
  HEADER__DONATE_LINK_CLOSE_ACTIVE: 'header__donate-link-close--active',
  HEADER__DONATE_LINK_CLOSE: 'header__donate-link-close',
  HEADER__DROPDOWN_ARROW: 'header__dropdown-arrow',
  HEADER__HAMBURGER: 'header__hamburger',
  HEADER__HAMBURGER_ACTIVE: 'header__hamburger--active',
  HEADER__MOBILE: 'header__mobile',
  HEADER__MOBILE_ACTIVE: 'header__mobile--active',
  HEADER__NAV_ITEM_MOBILE: 'header__nav-item--mobile',
  HEADER__NAVIGATION_CHILDREN_ACTIVE: 'header__navigation--children-m--active',
  HEADER__SEARCH_INPUT_ACTIVE: 'header__search-input--active',
  HEADER__SEARCH_INPUT: 'header__search-input',
  HEADER__SEARCH_ICON: 'header__search-icon',
  HERO_CAMPAIGN_CONTENT: 'hero-campaign__content',
  HERO_CAMPAIGN_POST_CONTENT: 'hero-campaign-post__content',
  HERO_CONTENT: 'hero--content',
  HERO_CAMPAIGN_VIDEO: 'campaign-hero__video',
  HERO_CAMPAIGN_VIDEO_PAUSE: 'campaign-hero__video-controls__pause',
  HERO_CAMPAIGN_VIDEO_PLAY: 'campaign-hero__video-controls__play',
  HERO_CAMPAIGN_WRAPPER: 'campaign-hero__wrapper',
  HERO_HOME: 'hero-home',
  HERO_HOME_CONTENT: 'hero-home__content',
  HERO_HOME_MOBILE_IMG: 'hero-home__mobile-img',
  HERO_HOME_PADDED: 'hero-home--padded',
  HERO_HOME_VIDEO: 'hero-home__video',
  HERO_HOME_VIDEO_PAUSE: 'hero-home__video-controls__pause',
  HERO_HOME_VIDEO_PLAY: 'hero-home__video-controls__play',
  HERO_HOME_WRAPPER: 'hero-home__wrapper',
  HERO_PAUSE: 'pause-bt--js',
  HERO_PLAY: 'play-bt--js',
  HERO_VIDEO: 'landing-hero-video',
  HERO_VIDEO_JS: 'landing-hero-video__video--js',
  HIDING: 'hiding',
  HIDDEN: 'hidden',
  HIDDEN_ITEMS: 'hidden--items',
  HOME_EMAIL_FORM: 'home-email-form',
  HIGHLIGHT_COMPONENT_WRAPPER: 'highlight-component__wrapper',
  HOME_EMAIL_BLOCK_EMAIL: 'home-email-block__email',
  HOME_STATISTICS_WRAPPER: 'home-statistics-section__items--wrapper',
  HOME_STATISTICS_CARD: 'home-statistics-section__item',
  HOVER: 'hover',
  HOVERED: 'hovered',
  ICON_CALLOUT_ICONS: 'icon-callout__icon',
  ICON_CALLOUT_LINKS: 'icon-callout__link',
  ICON_CALLOUT_WRAP: 'icon-callout__wrap',
  ICON_CALLOUT_ICON: 'icon-callout__icon',
  IMAGE_GRID_CARD_CONTAINER: 'image-gallery-grid__container-card-container',
  IMAGE_GRID_CARD_IMAGE:
    'image-gallery-grid__container-card-container__card-image__img',
  IMAGE_GRID_CARD_OVERLAY:
    'image-gallery-grid__container-card-container__card-image__overlay',
  IMAGE_GRID_CONTENT: 'image-gallery-grid__lightbox__content',
  IMAGE_GRID_LIGHTBOX: 'image-gallery-grid__lightbox',
  IMAGE_GRID_LIGHTBOX_CLOSE: 'image-gallery-grid__lightbox__content__close',
  IMAGE_GRID_LIGHTBOX_NEXT:
    'image-gallery-grid__lightbox__content__slides__controls__next',
  IMAGE_GRID_LIGHTBOX_PREV:
    'image-gallery-grid__lightbox__content__slides__controls__prev',
  IMAGE_GRID_LIGHTBOX_SLIDE:
    'image-gallery-grid__lightbox__content__slides__slide',
  IMAGE_GRID_LOAD_MORE: 'image-gallery-grid__load-more',
  IMAGE_SCROLLING_JS: 'image-scrolling--js',
  IMAGE_SCROLLING_ITEM_JS: 'image-scrolling__item--js ',
  IMAGE_SCROLLING_COLUMN_LEFT_JS: 'image-scrolling__column--left--js',
  IMAGE_SCROLLING_COLUMN_RIGHT_JS: 'image-scrolling__column--right--js',
  IMAGE_SCROLLING_CONTENT_AREA_JS: 'image-scrolling__content-area--js',
  IMAGE_SCROLLING_IMAGE: 'image-scrolling__image',
  INDEX_0: 'index-0',
  INTERIOR_HERO: 'interior-hero',
  INTERIOR_HERO_RIGHT_WRAPPER: 'interior-hero__right-wrapper',
  INTERIOR_HERO_TEXT_WRAPPER: 'interior-hero__text-wrapper',
  INTRODUCTION_LIST_DROPDOWN_CONTENT: 'introduction__list-dropdown-content',
  INTRODUCTION_LIST_DROPDOWN_ITEM: 'introduction__list-dropdown-item',
  INTRODUCTION_LIST_TOGGLE: 'introduction__list-toggle',
  INTRODUCTION_INTRO: 'introduction__intro',
  INTRODUCTION_LIST_ITEM: 'introduction__list-item',
  INTRODUCTION_LIST_ITEM_TERTIARY: 'introduction__list-item--tertiary',
  INTRODUCTION_LIST_SELECT: 'introduction__list-select',
  INTRODUCTION_SUBSECTION_TERTIARY: 'introduction__subsection--tertiary',
  IN_VIEWPORT: 'in-viewport',
  INVALID: 'invalid',
  IS_ACTIVE: 'is-active',
  IS_HIDDEN: 'is-hidden',
  IS_VISIBLE: 'is-visible',
  IS_IN_VIEWPORT: 'is-in-viewport',
  ITEM: 'item',
  LABEL_CASE_REASON: 'label-case-reason',
  LABEL_TOPIC: 'label-topic',
  LABEL_TYPE: 'label-type',
  LANDING_HERO: 'landing-hero',
  LANDING_HERO_CONTENT: 'landing-hero__content',
  LANDING_HERO_VIDEO_TEXT_WRAPPER: 'landing-hero-video__text-wrapper',
  LARGE_PIE: 'large-pie',
  LIGHTBOX: 'lightbox',
  LIGHTBOX_BTN: 'button__primary',
  LIGHTBOX_CLOSE: 'lightbox__close-btn',
  LIGHTBOX_CIRCLE_SVG: '.lightbox__image-circle svg',
  LIGHTBOX_CIRCLE_SCALE: 'lightbox__image-circle--scale',
  LIGHTBOX_OVERLAY: 'lightbox__overlay',
  LINK_LISTING_ITEM: 'link-listing__item',
  LISTING_CARDS_HOVER: 'listing-cards--hover',
  LISTING_CARDS_EYEBROW_HOVER: 'listing-cards--eyebrow-hover',
  LISTING_FILTERS: 'listing-filters',
  LOADING: 'loading',
  MAP_CHECKBOX: '.work-map__key-checkbox input[type="checkbox"]',
  MAP_CONTAINER: 'work-map__map-container',
  MAP_COUNTRY: '.work-map__data > .country',
  MAP_COUNTRY_COUNTRY: '.work-map__map',
  MAP_CLOSE: '.work-map-tooltip__close',
  MAP_LAND_PATH: '.landxx',
  MAP_TOOLTIP: 'tooltip',
  MAP_OVERLAY: 'work-map__overlay',
  MAP_SVG: '.work-map__map-container svg',
  MAP_REGION_COL_COUNTRIES: 'map-region-col__countries',
  MAP_REGION_COL_TITLE: 'map-region-col__title',
  MAP_REGION_COL_TITLE_MINUS: 'map-region-col__title--minus',
  MAP_REGION_COL_COUNTRIES_MENU_EXPAND:
    'map-region-col__countries--menu-expand',
  MEGA_BANNER_CLOSED: 'mega-banner-cta-closed',
  MEGA_BANNER_EXPAND: 'mega-banner-cta-closed--expand',
  MINI: 'mini',
  MINUS: 'minus',
  NAV: 'nav',
  NAV_LEFT: 'nav-left',
  NAV_RIGHT: 'nav-right',
  NEWS_HERO: 'news-hero',
  NO_IMAGE: 'no-image',
  NO_SCROLL: 'no-scroll',
  NEWS_HERO__DROPDOWN: 'news-hero__dropdown',
  NEWS_HERO__DROPDOWN_IS_OPEN: 'is-open',
  NEWS_HERO__DROPDOWN_UL: 'ul',
  OPEN: 'open',
  OPEN_MEGA_BANNER: 'open-mega-banner',
  OPENED: 'opened',
  PRIMARY_FEATURED_CONTENT_CIRCLE: 'primary-featured-content__circle',
  PRIMARY_FEATURED_CONTENT_CIRCLE_INNER:
    'primary-featured-content__circle-inner',
  QUOTE_INNER_MAIN: 'quote__inner-main',
  QUOTE_INNER_SUB: 'quote__inner-sub',
  RESOURCE_FILTERS__DESKTOP: 'resource-filters--desktop',
  RESOURCE_FILTERS__FILTER_ITEM: 'resource-filters__filter-item',
  RESOURCE_FILTERS__FILTER_LIST: 'resource-filters__filter-list',
  RESOURCE_FILTERS__MOBILE: 'resource-filters--mobile',
  RESOURCE_FILTERS__QUICK_SELECT: 'resource-filters__quick-select',
  REQUIRED: 'required',
  SCROLLED: 'scrolled',
  SCROLLED_BRANDING: 'scrolled-branding',
  SCROLLED_DONATE: 'scrolled-donate',
  SCROLLED_NAV: 'scrolled-nav',
  SCROLLED_SEARCH_INPUT: 'scrolled-search-input',
  SCROLL_TARGET: 'introduction',
  SEARCH: 'search',
  SEARCHING: 'searching',
  SELECT_ALL: 'select-all',
  SELECTED: 'selected',
  SHOW: 'show',
  SLIDESHOW_COUNTER_PREV: 'slideshow__counter-prev',
  SLIDESHOW_COUNTER_NEXT: 'slideshow__counter-next',
  SLIDESHOW_COUNTER_CURRENT: 'slideshow__counter-current',
  SLIDESHOW_SLIDE_IMAGE: 'slideshow__slide-image',
  SLIDESHOW_SLIDE_HEADLINE: 'slideshow__slide-headline',
  SLIDESHOW_SLIDE_DESCRIPTION: 'slideshow__slide-description',
  SLIDESHOW_DATA: 'slideshow__data',
  SNAPSHOT_CAROUSEL: 'snapshot__carousel',
  SNAPSHOT_CAROUSEL_TRACK: 'snapshot__carousel--track',
  SOCIAL_HIGHLIGHTS_GRID_SIZER: 'social-highlights__grid-sizer',
  SOCIAL_HIGHLIGHTS_GUTTER_SIZER: 'social-highlights__gutter-sizer',
  SOCIAL_HIGHLIGHTS_POST: 'social-highlights__post',
  SOCIAL_HIGHLIGHTS_POSTS: 'social-highlights__posts',
  STICKY: 'sticky',
  SLIM_QUOTE_QUOTATION: 'slim-qoute__quote__quotation',
  STORY_NAVIGATION_DROPDOWN: 'story-navigation__dropdown',
  STORY_NAVIGATION_LIST: 'story-navigation-list',
  SUB_MENU: 'sub-menu',
  SUCCESS: 'success',
  TABS: 'tabs',
  TABS_BUTTONS: 'a',
  TAB_CONTENT_MAIN: 'tabbed-content-main',
  TEMPLATE: 'template',
  THREE_UP_TITLE: 'three-up__title',
  TIMELINE_EVENT_CONTENT: 'timeline__event-content',
  TIMELINE_EVENT_CONTENT_VISIBLE: 'timeline__event-content--visible',
  TIMELINE_EVENT_VIDEO: 'timeline__event--video',
  TIMELINE_EVENT_VIDEO_EMBED: 'timeline__event-video-embed',
  TIMELINE_EVENT_VIDEO_PLAY: 'timeline__event-video-play',
  TIMELINE_EVENT_VIDEO_THUMBNAIL: 'timeline__event-video-thumbnail',
  TO_TOP_BUTTON: 'span',
  TOPIC: 'topic',
  TOGGLE_MEGA_BANNER: 'toggle-mega-banner',
  TWO_UP_STATS_COUNTER: 'two-up-stats__counter',
  TWO_UP_STATS_COUNTER_VALUE: 'two-up-stats__counter-value',
  TWO_UP_STATS_PIE: 'two-up-stats__pie',
  UPDATE_DONATION_SELECTED: 'update-donation-selected',
  VALID: 'valid',
  VIDEO: 'video--js',
  VIDEO_LIGHTBOX: 'video-lightbox',
  VIDEO_OPEN_LIGHTBOX_JS: 'video-open-lightbox-js',
  VIDEO_WRAPPER: 'video-wrapper',
  VIDEO_PLAY: 'play--js',
  VIDEO_THUMBNAIL: 'thumbnail--js',
  VISIBLE: 'visible',
  VISUALLY_HIDDEN: 'visually-hidden',
  WITH_IMAGE: 'with-image'
};

export default CLASS_NAMES;
